var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4EBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9F5FF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0817 35V33.0966L28.1314 28.1463C28.6143 27.6586 29.0168 27.2254 29.3388 26.8466C29.6607 26.4678 29.9022 26.1009 30.0632 25.7457C30.2242 25.3906 30.3047 25.0118 30.3047 24.6094C30.3047 24.1501 30.2005 23.7571 29.9922 23.4304C29.7839 23.099 29.4974 22.8433 29.1328 22.6634C28.7682 22.4834 28.3539 22.3935 27.8899 22.3935C27.4117 22.3935 26.9927 22.4929 26.6328 22.6918C26.273 22.8859 25.9936 23.1629 25.7947 23.5227C25.6006 23.8826 25.5036 24.3111 25.5036 24.8082H22.9964C22.9964 23.8849 23.2071 23.0824 23.6286 22.4006C24.05 21.7187 24.63 21.1908 25.3686 20.8168C26.112 20.4427 26.9643 20.2557 27.9254 20.2557C28.9008 20.2557 29.7578 20.438 30.4964 20.8026C31.2351 21.1671 31.808 21.6667 32.2152 22.3011C32.6271 22.9356 32.8331 23.66 32.8331 24.4744C32.8331 25.0189 32.7289 25.554 32.5206 26.0795C32.3123 26.6051 31.9453 27.1875 31.4197 27.8267C30.8989 28.4659 30.1674 29.2401 29.2251 30.1491L26.718 32.6989V32.7983H33.0533V35H23.0817Z",
    fill: "#7F56D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a9830b6e724207ee685607a67ea6bf0a.svg";
export { ForwardRef as ReactComponent };